<template>
  <div class="modal">
    <audio ref="ttsAudio" hidden @pause="onAudioPaused" @ended="onAudioEnded"></audio>
    <!-- 현재 재생 멈추는 모달 -->
    <ConfirmYesNoV2
      v-if="isStopAndRecordModal"
      @click-no="onClickStopAndTTSCancel"
      @click-yes="onClickStopAndTTSConfirm"
    >
      <template #confirmmodal-nontitle>
        현재 재생중인 음악을 잠시 멈추고 <br />
        미리듣기를 시작하시겠습니까?
      </template>
    </ConfirmYesNoV2>

    <!-- 이용 초과 -->
    <AlertModalV2 v-if="isOverModal" @confirm-btn="isOverModal = false">
      <template #alertmodal-nontitle v-if="spacetype === 'T'"> {{ overUseText }}</template>
      <template #alertmodal-title v-if="spacetype === 'Y'">
        {{ overUseText }}
      </template>
      <template #alertmodal-desc v-if="spacetype === 'Y'"> {{ resetdate }} 이후 다시 이용가능합니다 </template>
    </AlertModalV2>

    <!-- 텍스트 초과 경고 모달 -->
    <AlertModalV2 v-if="isOverText" @confirm-btn="isOverText = false">
      <template #alertmodal-nontitle> 텍스트는 최대 200자까지 작성 가능합니다.</template>
    </AlertModalV2>

    <!-- 파일 등록 완료 -->
    <AlertModalV2 v-if="isSuccessFile" @confirm-btn="onConfirmBtnSuccessFile">
      <template #alertmodal-nontitle> 파일이 등록되었습니다.</template>
    </AlertModalV2>

    <!-- 이번달 이용 횟수를 모두 사용하셨어요. -->
    <AlertModalV2 v-if="isOverUser" @confirm-btn="isOverUser = false">
      <template #alertmodal-nontitle>
        이번달 이용 횟수를 모두 사용하셨어요.
      </template>
    </AlertModalV2>

    <div class="broadcastfile-modal">
      <div class="broadcastfile-header">
        <div class="header-wrap">
          <img class="arrow-left-icon cursor" src="/media/images/icon/arrow-left-icon.png" alt="arrow-left-icon.png" />
          <h1 class="header-title">AI 보이스</h1>
        </div>
        <a class="common-close-iconwrap  cursor" tabindex="0" @click="onClickClose">
          <img class="common-close-iconwrap" src="/media/images/icon/close-black-icon.png" alt="close-black-icon.png" />
        </a>
      </div>
      <!-- broadcastfile-contents -->
      <div class="broadcastfile-contents">
        <!-- Step 1 : TTS-->
        <h1 class="step-title" v-if="step === 1">AI 보이스로 변환할 텍스트를 입력해주세요.</h1>
        <p class="max-onemin" v-if="step === 1">(최대 200자)</p>
        <p class="step-exampletext" v-if="step === 1">
          ex) 저희 매장의 영업 종료 시간은 오후 10시입니다. <br />
          필요하신 메뉴는 9시까지 주문해 주세요.
        </p>
        <textarea
          class="texttospeach-textarea"
          v-if="step === 1"
          :value="textContents"
          :placeholder="'텍스트를 입력해주세요.'"
          @input="onInputText"
        ></textarea>
        <div class="texttospeach-form" v-if="step === 1">
          <label class="form-label">
            선호 목소리
          </label>
          <div class="select-prefer-voicetab">
            <a
              class="select-prefer-btn cursor women"
              @click="onClickSelect('female')"
              :class="voiceType === 'female' ? 'active' : ''"
              tabindex="0"
            >
              👩🏻‍🦰 여자
            </a>
            <a
              class="select-prefer-btn men cursor"
              tabindex="0"
              @click="onClickSelect('male')"
              :class="voiceType === 'male' ? 'active' : ''"
            >
              👦🏻 남자
            </a>
          </div>

          <div class="preview-btnwrap">
            <BasicButton
              :boxsize="'sm'"
              @click-btn="onClickBtnPreview"
              :fontcolor="'ft-black'"
              :bgcolor="'bg-white'"
              :boxshadow="'boxshadow'"
            >
              <template #before-icon>
                <img
                  v-if="isTTSplay"
                  class="pause-icon"
                  src="/media/images/icon/pause-black-icon.png"
                  alt="play-black-icon.png"
                />
                <img v-else class="play-icon" src="/media/images/icon/play-black-icon.png" alt="play-black-icon.png" />
                <!-- -->
              </template>
              <template #btnname>미리듣기</template>
            </BasicButton>
          </div>
        </div>

        <!-- Step2 : 파일명 입력-->
        <h1 class="step-title" v-if="step === 2">파일명을 설정해주세요.</h1>
        <div class="inputbox" v-if="step === 2">
          <InputBox
            ref="inputboxWrap"
            :placeholder="'ex) 오프닝 멘트'"
            :value="fileName"
            @change-input="onChangeInput"
          ></InputBox>
        </div>

        <div class="error-wrap" v-if="step === 2 && fileName.length > 10">
          <ErrorMessage :errortext="'파일명은 띄어쓰기 포함 10글자까지만 가능합니다.'" />
        </div>
      </div>

      <div class="broadcastfile-footer">
        <div class="next-btn">
          <BasicButton :boxsize="'sm'" :disabled="btnDisabled" @click-btn="onClickNextBtn">
            <template #btnname>다음</template>
          </BasicButton>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BasicButton from '../BasicButton/BasicButton.vue';
import InputBox from '../InputBox/InputBox.vue';
import ErrorMessage from '../ErrorMessage/ErrorMessage.vue';
import ConfirmYesNoV2 from '../common/ConfirmYesNoV2.vue';
import AlertModalV2 from '../modal/AlertModalV2.vue';
import { downloadTTSFile, listenTextPreviously, registMySoundByText } from '@/service/api/mysound';
import { getMysndCountAndResetDateApi } from '@/service/api/mySoundApi';
export default {
  props: {
    spacetype: {
      type: String,
      default: null, // T : 체험용 , Y : 구독
      required: false
    },
    resetdate: {
      // 만료 일자
      type: String,
      default: null,
      required: false
    }
  },
  components: {
    BasicButton,
    InputBox,
    ErrorMessage,
    ConfirmYesNoV2,
    AlertModalV2
  },
  emits: ['close-aivoice', 'success-file'],
  data() {
    return {
      step: 1,
      userId: this.$cookies.get('userId'),
      spaceId: this.$cookies.get('spaceId'),

      title: '',
      textContents: '',
      isStopAndRecordModal: false,
      voiceType: 'female',
      isBtnDisabled: false,
      isPreviewBtnDisabled: false,
      isChangeTextvalue: false,
      fileInfo: null,
      listenableCnt: 10,
      isOverModal: false,
      isTTSplay: false,
      fileName: '',
      isSuccessFile: false,
      isOverUser: false,
      isOverText: false,
      isPlayedTTS: false // 이미 재생 한적이 있는지 체크
    };
  },
  async created() {
    await this.getLimite();
  },
  methods: {
    onChangeInput(val) {
      this.fileName = val;
      if (this.fileName.length > 10) {
        setTimeout(() => {
          this.fileName = val.slice(0, 10);
          this.$refs.inputboxWrap.textSlice();
        }, 800);
      }
    },
    onAudioPaused() {
      this.isTTSplay = false;
    },
    onAudioEnded() {
      this.isTTSplay = false;
      // 웰컴 AI음악이 재생되는 경우 음소거 해제
      if (this.$store.getters['player/getIsPlayAiMusicSong']) {
        document.querySelector('video#aimusic_video').muted = false;
      }
    },
    onConfirmBtnSuccessFile() {
      this.isSuccessFile = false;
      this.$emit('success-file');
    },
    onClickBtnPreview() {
      this.$gatag.event('web_broadcast_tts_page_pre_speech'); // 미리 듣기
      if (this.isPreviewBtnDisabled || !this.textContents) return;
      // AIMusic이 진행되는 경우
      if (this.$store.state.isPlay) {
        this.$gatag.event('web_broadcast_detail_page_pre_speech'); // 재생중 미리듣기 팝업
        this.isStopAndRecordModal = true;
        return;
      }
      if (this.isTTSplay) {
        this.$refs.ttsAudio.pause();
        return;
      }
      this.playSet();
    },
    async getLimite() {
      try {
        const { data } = await getMysndCountAndResetDateApi(this.userId, this.spaceId);
        const { resultCd, result } = data;
        if (resultCd === '0000') {
          const { tts } = result;
          this.listenableCnt = tts.availableCount;
        } else {
          throw Error(resultCd);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async playSet() {
      if (this.listenableCnt === 0 && this.isChangeTextvalue) {
        this.isOverModal = true;
        return;
      }

      if (this.isChangeTextvalue) {
        try {
          this.isPreviewBtnDisabled = true;
          const param = {
            userId: this.userId,
            spaceId: this.spaceId,
            textOfMessage: this.textContents,
            voiceType: this.voiceType,
            voiceName: this.voiceType
          };
          const { data } = await listenTextPreviously(param);
          const { resultCd, result } = data;
          if (resultCd === '0000') {
            this.fileInfo = result;
            this.isPlayedTTS = true;
            const ttsParam = {
              userId: this.userId,
              spaceId: this.spaceId,
              tempNo: this.fileInfo.tempNo
            };
            const { data: ttsData } = await downloadTTSFile(ttsParam);
            const { resultCd: ttsResultCd, result: ttsResult } = ttsData;
            if (ttsResultCd === '0000') {
              const videoSrc = 'data:audio/mpeg;base64,' + ttsResult.body;

              // ttsAudio
              this.$refs.ttsAudio.src = videoSrc;
              this.isTTSplay = true;
              this.$refs.ttsAudio.play();

              await this.getLimite();

              this.isChangeTextvalue = false;
            } else {
              throw Error('error ' + ttsResultCd);
            }
          } else {
            throw Error(resultCd);
          }
        } catch (error) {
          if (error.response) {
            const { data } = error.response;
            const { resultCd } = data;
            if (resultCd === '24003') {
              this.isOverUser = true;
            }
          }
        } finally {
          this.isPreviewBtnDisabled = false;
        }
      } else {
        this.isTTSplay = true;
        this.$refs.ttsAudio.play();
      }
    },
    onClickSelect(type) {
      if (type !== this.voiceType) {
        this.isChangeTextvalue = true;
        this.isPlayedTTS = false;
      }
      this.voiceType = type;
    },
    /**
     * @description
     * @param $event
     */
    onInputText($event) {
      if ($event.target) {
        this.isChangeTextvalue = true;
        this.isPlayedTTS = false;
        if ($event.target.value.length > 200) {
          $event.target.value = $event.target.value.slice(0, 200);
          this.isOverText = true;
        }
        this.textContents = $event.target.value.slice(0, 200);
      }
    },
    onClickStopAndTTSCancel() {
      this.isStopAndRecordModal = false;
    },
    onClickStopAndTTSConfirm() {
      this.$store.dispatch('controlMusic');
      this.isStopAndRecordModal = false;
      this.playSet();
    },
    onClickClose() {
      this.$gatag.event('web_broadcast_tts_page_back'); // TTS 페이지 뒤로가기
      this.$emit('close-aivoice');
    },
    async onClickNextBtn() {
      if (this.step === 1) {
        try {
          this.$gatag.event('web_broadcast_tts_page_next'); // TTS 다음 버튼
          this.isBtnDisabled = true;
          if (!this.isPlayedTTS) {
            const param = {
              userId: this.userId,
              spaceId: this.spaceId,
              textOfMessage: this.textContents,
              voiceType: this.voiceType,
              voiceName: this.voiceType
            };
            const { data } = await listenTextPreviously(param);
            const { resultCd, result } = data;
            if (resultCd === '0000') {
              this.fileInfo = result;
              this.step = 2;
            } else {
              throw Error(resultCd);
            }
          } else {
            this.step = 2;
          }
        } catch (error) {
          console.log(error);
          if (error.response) {
            const { data } = error.response;
            const { resultCd } = data;
            if (resultCd === '24003') {
              this.isOverUser = true;
            }
          }
        } finally {
          this.isBtnDisabled = false;
        }
      } else {
        try {
          this.isBtnDisabled = true;
          const param = {
            userId: this.userId,
            spaceId: this.spaceId,
            soundTitle: this.fileName,
            tempNo: this.fileInfo.tempNo
          };
          const { data } = await registMySoundByText(param);
          const { resultCd } = data;
          if (resultCd === '0000') {
            this.isSuccessFile = true;
          } else {
            throw Error(resultCd);
          }
        } catch (error) {
          console.log(error);
        } finally {
          this.isBtnDisabled = false;
        }
      }
    }
  },
  computed: {
    btnDisabled() {
      if (this.step === 1) {
        if (this.textContents) {
          return this.isBtnDisabled;
        }
      } else if (this.step === 2) {
        if (this.fileName) {
          return this.isBtnDisabled;
        }
      }
      return true;
    },
    previewBtnDisabled() {
      if (this.textContents) {
        return this.isPreviewBtnDisabled;
      }
      return true;
    },
    overUseText() {
      if (this.spacetype === 'T') {
        return `이번달 이용횟수를 모두 사용하셨어요.`;
      } else if (this.spacetype === 'Y') {
        return `이번달 이용 가능횟수를 모두 사용하셨습니다.`;
      }
      return '';
    }
  }
};
</script>
<style scoped src="@/assets/css/broadcastfile/broadcastfile.css"></style>
